import React from 'react'
import { LinkedinOutlined } from '@ant-design/icons'
import { LinkedIn } from 'components/Icons/Icons'

import './style.scss'

interface LinkedinIconProps {
    companyname: string | undefined
    profileId: string | undefined
}

export const LinkedinIcon = ({ companyname = 'icloud-ready' }: LinkedinIconProps) => {
    const url = `https://linkedin.com/company/${companyname}`

    return (
        <a href={url} className="linkedin-user-link -mt-4 mb-4 inline-block opacity-75 hover:opacity-100">
            <LinkedinOutlined style={{ fontSize: '22px', fill: 'fill-current', verticalAlign: 'baseline' }} />
        </a>
    )
}

export const LinkedinIconPersonal = ({ profileId = '' }: LinkedinIconProps) => {
    const url = `https://linkedin.com/in/${profileId}`

    return (
        <a href={url} className="linkedin-user-link -mt-4 mb-4 inline-block opacity-75 hover:opacity-100">
            <LinkedinOutlined style={{ fontSize: '22px', fill: 'fill-current', verticalAlign: 'baseline' }} />
        </a>
    )
}
